(() => {
  const configNode = document.getElementById('cd-shopping-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const key = 'cd-favorites-v1';
  const valid = x => typeof x === 'string' && /^[a-z0-9-]+$/.test(x);
  const read = () => {
    try { const value = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(value) ? [...new Set(value.filter(valid))].slice(0, 60) : []; }
    catch { return []; }
  };
  const status = document.getElementById('cd-shopping-status');
  const announce = message => { if (status) status.textContent = message; };
  function preserveAvailability() {
    const availableOnly = new URL(location.href).searchParams.get('filter.v.availability') === '1';
    document.querySelectorAll('facet-filters-form form').forEach(form => {
      let input = form.querySelector('input[data-cd-availability]');
      if (availableOnly && !input && !form.querySelector('[name="filter.v.availability"]')) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'filter.v.availability';
        input.value = '1';
        input.dataset.cdAvailability = '';
        form.append(input);
      } else if (!availableOnly && input) input.remove();
    });
  }
  function syncSizes() {
    document.querySelectorAll('[data-cd-size]').forEach(link => {
      const url = new URL(location.href);
      const name = link.dataset.cdSizeParam;
      const value = link.dataset.cdSize;
      const values = url.searchParams.getAll(name);
      const active = values.includes(value);
      url.searchParams.delete('page');
      url.searchParams.delete(name);
      const next = active ? values.filter(v => v !== value) : [...values,value];
      next.forEach(v => url.searchParams.append(name,v));
      url.searchParams.set('filter.v.availability','1');
      link.href = url.pathname + url.search;
      link.classList.toggle('is-active',active);
      if (active) link.setAttribute('aria-current','true'); else link.removeAttribute('aria-current');
    });
  }
  function refresh() {
    preserveAvailability();
    syncSizes();
    const saved = read();
    document.querySelectorAll('[data-cd-favorite]').forEach(button => {
      button.hidden = false;
      const active = saved.includes(button.dataset.cdFavorite);
      button.setAttribute('aria-pressed', String(active));
      const label = button.querySelector('[data-cd-favorite-label]');
      const message = active ? config.saved : config.save;
      if (label && label.textContent !== message) label.textContent = message;
    });
  }
  document.addEventListener('click', event => {
    const apply = event.target.closest('[data-cd-facet-apply]');
    if (!apply) return;
    const drawer = apply.closest('menu-drawer');
    if (!drawer) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const disclosure = drawer.querySelector('details');
    const summary = disclosure.querySelector('summary');
    disclosure.querySelectorAll('details').forEach(detail => {
      detail.removeAttribute('open');
      detail.classList.remove('menu-opening');
    });
    disclosure.querySelectorAll('.submenu-open').forEach(element => element.classList.remove('submenu-open'));
    disclosure.removeAttribute('open');
    disclosure.classList.remove('menu-opening');
    summary.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden-mobile');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(summary);
    summary.focus();
  }, true);
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-cd-favorite]');
    if (!button) return;
    const handle = button.dataset.cdFavorite;
    if (!valid(handle)) return;
    const saved = read();
    const next = saved.includes(handle) ? saved.filter(x => x !== handle) : [...saved, handle].slice(-60);
    try { localStorage.setItem(key, JSON.stringify(next)); }
    catch { announce(config.storage_error); return; }
    refresh();
    announce(config.favorites_updated);
    const listItem = button.closest('[data-cd-saved-item]');
    if (listItem && !next.includes(handle)) {
      const nextFocus = listItem.nextElementSibling?.querySelector('a') || listItem.previousElementSibling?.querySelector('a') || document.querySelector('[data-cd-favorites] > a');
      listItem.remove();
      nextFocus?.focus();
      const state = document.querySelector('[data-cd-favorites-status]');
      if (state && !next.length) state.textContent = config.favorites_empty;
    }
  });
  document.addEventListener('change', event => {
    const form = event.target.closest('form.cd-preferences-form');
    if (!form) return;
    const tags = ['newsletter','clearance-signup'];
    form.querySelectorAll('[data-cd-pref]').forEach(input => {
      if (input.type === 'checkbox' ? input.checked : Boolean(input.value)) tags.push(input.dataset.cdPref + input.value);
    });
    form.querySelector('[name="contact[tags]"]').value = tags.join(',');
  });
  const observer = new MutationObserver(() => refresh());
  observer.observe(document.getElementById('MainContent'), {childList:true, subtree:true});
  refresh();
  window.addEventListener('popstate', refresh);
  window.addEventListener('storage', event => { if (event.key === key) refresh(); });
  async function renderFavorites() {
    const root = document.querySelector('[data-cd-favorites]');
    if (!root) return;
    const list = root.querySelector('[data-cd-favorites-list]');
    const state = root.querySelector('[data-cd-favorites-status]');
    const saved = read();
    if (!saved.length) { state.textContent = config.favorites_empty; return; }
    const make = (tag, text, className) => {
      const element = document.createElement(tag);
      if (text) element.textContent = text;
      if (className) element.className = className;
      return element;
    };
    for (let offset = 0; offset < saved.length; offset += 4) {
      const items = await Promise.all(saved.slice(offset,offset+4).map(async handle => {
        const li = make('li', '', 'cd-saved-card');
        li.dataset.cdSavedItem = handle;
        try {
          const response = await fetch(config.root + 'products/' + encodeURIComponent(handle) + '.js');
          if (!response.ok) throw new Error(response.status === 404 ? 'missing' : 'network');
          const p = await response.json();
          const link = make('a');
          link.href = config.root + 'products/' + encodeURIComponent(handle);
          if (p.featured_image) {
            const image = make('img');
            image.src = p.featured_image + (p.featured_image.includes('?') ? '&' : '?') + 'width=500';
            image.alt = p.title; image.loading = 'lazy'; image.width = 500; image.height = 625;
            link.append(image);
          }
          link.append(make('h2', p.title));
          li.append(link);
          const money = new Intl.NumberFormat(config.locale, {style:'currency',currency:config.currency}).format(p.price / 100);
          li.append(make('p', money));
          li.append(make('p', p.available ? p.variants.filter(v => v.available).map(v => v.title).join(' · ') : config.sold));
          if (!p.available) { const browse = make('a', config.browse); browse.href = config.root + 'collections/all?filter.v.availability=1'; li.append(browse); }
        } catch(error) {
          li.append(make('p', error.message === 'missing' ? config.unavailable : config.load_error));
        }
        const button = make('button', '', 'cd-favorite');
        button.type = 'button'; button.dataset.cdFavorite = handle; button.setAttribute('aria-pressed','true');
        const label = make('span', config.remove); label.dataset.cdFavoriteLabel = '';
        button.append(label); li.append(button);
        return li;
      }));
      list.append(...items);
    }
    state.textContent = '';
    refresh();
  }
  renderFavorites();
})();
